import { faPlay, faSpinner } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { push } from 'connected-react-router';
import * as React from 'react';
import { connect } from 'react-redux';
import { Col, Container, Row } from 'reactstrap';
import { bindActionCreators, Dispatch } from 'redux';
import { ApplicationState } from '../../../store';
import * as ConsoleStore from '../../../store/Console';
import { Application } from '../../../store/Console';
import './Applications.scss';

type ApplicationsDashViewProps = {
} & ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

class ApplicationsDashView extends React.Component<ApplicationsDashViewProps, any> {
    private onLaunch = (event: React.MouseEvent, object: Application) => {
        event.preventDefault();
        this.props.consoleActions.launchApplication(object);
    }

    private displayUserName = () => {
        return (this.props.console?.userProfileState.isLoading ? (
            <FontAwesomeIcon icon={faSpinner} spin />
        ) : (
            <span>{this.props.console?.userProfileState.userProfile.firstName} {this.props.console?.userProfileState.userProfile.lastName}</span>
        ));
    }

    public render() {
        return (
            <>
                <Container className="mt-2">
                    {this.props.console?.applicationsState.isLoading && (
                        <section className="text-center">
                            <FontAwesomeIcon icon={faSpinner} size="2x" spin={true} />
                        </section>
                    )}
                    {!this.props.console?.applicationsState.isLoading && this.props.console?.applicationsState.applications.map((value, index) => {
                        return ((value.display && value.type != "PortalHome") ?? false) ? (
                            <Row key={index}>
                                <Col xs={{ size: 12 }}>
                                    <div className="app-card">
                                        <div className="left-box">
                                            <h5>{value.displayName}</h5>
                                            <div>
                                                {value.description}
                                            </div>
                                        </div>
                                        <div className="right-box">
                                            <div className="app-activator">
                                                <div className="content">
                                                    {value.shortcuts}
                                                </div>
                                                <div className="activate-holder">
                                                    <div className="activate bg-primary launchButton">
                                                        <a href="#!" onClick={(event) => this.onLaunch(event, value)}>LAUNCH<FontAwesomeIcon icon={faPlay} className="ms-2" fixedWidth /></a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        ) : null
                    })}
                </Container>
            </>
        );
    }
}

const mapStateToProps = (state: ApplicationState) => {
    return {
        console: state.console,
        router: state.router
    }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        push: (path: string) => dispatch(push(path)),
        consoleActions: bindActionCreators(ConsoleStore.actionCreators, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ApplicationsDashView);
